/*jshint esversion: 9 */
import React from 'react';
import { confirmable } from 'react-confirm';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

class GetConfirmation extends React.Component {

    render() {
        const {
            okLabel = 'OK',
            cancelLabel = 'Cancel',
            title,
            confirmation,
            show = "true",
            proceed,
            //dismiss = this.dismiss,
            cancel,
            //modal = "true",
        } = this.props;
        // console.log('[GetConfirmation] props:', this.props);

        return (
            <Dialog
                open={show}
                onClose={() => cancel('dialog closed without choice')}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {confirmation}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => proceed('proceed selected')} color="primary" autoFocus>
                        {okLabel}
                    </Button>
                    <Button onClick={() => cancel('cancel selected')} color="primary">
                        {cancelLabel}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default confirmable(GetConfirmation);